var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6196 6.42621C15.4097 5.27225 13.795 4.6436 12.1243 4.66943C9.06717 4.66943 6.47075 6.73191 5.54499 9.50916V9.50923C5.05412 10.9646 5.05412 12.5405 5.54498 13.9959H5.54928C6.47934 16.7689 9.07146 18.8314 12.1286 18.8314C13.7067 18.8314 15.0615 18.4277 16.1115 17.7148V17.7119C17.3473 16.8938 18.1913 15.6063 18.4539 14.1509H12.1243V9.63841H23.1774C23.3152 10.4221 23.3798 11.223 23.3798 12.0195C23.3798 15.5837 22.106 18.5971 19.8897 20.638L19.892 20.6398C17.9501 22.431 15.2848 23.4688 12.1243 23.4688C7.69359 23.4688 3.64179 20.9714 1.65249 17.0143V17.0143C-0.0095498 13.7031 -0.00954574 9.80201 1.6525 6.49083H1.65253L1.65249 6.4908C3.64179 2.52943 7.69359 0.0320397 12.1243 0.0320397C15.035 -0.00240705 17.8468 1.09128 19.9652 3.08058L16.6196 6.42621Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/googleIcon.53c819c92bbacb8a40774c912971a733.svg";
export { ForwardRef as ReactComponent };